export const useTemplateSnippet = () => {
  const format = (text: string, params: Record<string, string | number>) => {
    if (!text || !params) {
      return text;
    }

    return text.replace(/\{([^}]+)\}/g, (match, key) => {
      if (params[key] !== undefined && params[key] !== null) {
        return String(params[key]);
      }
      return match;
    });
  };

  return {
    format,
  };
};
